/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Feature, Product, ProductType } from "@/model/entities/entity-model";
import { AgFns } from "@/shared/ag-fns";
import { ColDef, ValueGetterParams, ValueSetterParams } from "@ag-grid-community/core";
import _ from "lodash";

type GetProductFn = (params: any) => Product;

type FormatFeatureChoiceFn = (product: Product, featureName: string, featureChoiceValue: string) => string;

export class ProductFns {
  static getAllFeaturesColDef(getProductFn: GetProductFn = (params) => params.data as Product) {
    return {
      headerName: "All Features",
      colId: "f-all-features",
      editable: false,
      sortable: false,
      ...AgFns.flexWidth(100),
      valueGetter: (params) => {
        const prod = getProductFn(params);
        if (prod == null) return "";
        const s = prod
          .getOrderedProductFeatureChoices()
          .map((pfc) => pfc.featureChoice.feature.getDisplayName() + ": " + pfc.featureChoice.choiceValue)
          .join(", ");
        return s;
      },
    };
  }

  static getAllFeaturesFromProduct(product: Product) {
    if (!product) return "";
    return product
      .getOrderedProductFeatureChoices()
      .map((pfc) => pfc.featureChoice.feature.getDisplayName() + ": " + pfc.featureChoice.choiceValue)
      .join(", ");
  }

  static getColDefsForProductType(productType?: ProductType, getProductFn: GetProductFn = (params) => params.data as Product) {
    if (productType == null) {
      return [] as ColDef[];
    }
    const orderedFeatures = _.orderBy(productType.productTypeFeatureMaps, (x) => x.displayOrder).map((ptf) => ptf.feature);
    const colDefs = this.getFeatureColDefs(orderedFeatures, getProductFn);
    return colDefs;
  }

  static getFeatureColDefs(features: Feature[], getProductFn: GetProductFn = (params) => params.data as Product) {
    const featureColDefs = features.map((x) => this.createFeatureColDef(x, getProductFn));
    return featureColDefs;
  }

  static createFeatureColDef(feature: Feature, getProductFn: GetProductFn = (params) => params.data as Product) {
    return {
      headerName: feature?.getDisplayName(),
      colId: "f" + feature?.name,
      maxWidth: 140,
      editable: false,
      sortable: false,
      valueGetter: (params) => {
        const prod = getProductFn(params);
        if (prod == null) return;
        const pfc = prod.productFeatureChoices.find((fc) => fc.featureChoice?.featureId == feature.id);
        return pfc?.featureChoice.choiceValue ?? "";
      },
    } as ColDef;
  }
}
